import { gql } from '@apollo/client';

export const CHAT_BETWEEN_USERS = gql`
  query ChatBetweenUsers($userId1: String!, $userId2: String!) {
    chatBetweenUsers(userId1: $userId1, userId2: $userId2) {
      _id
      members {
        _id
        username
        profilePhoto {
          url
          thumbnailUrl
        }
        photos {
          url
          thumbnailUrl
        }
      }
      messages(input: { type: "page", pageArgs: { page: 1, limit: 500 } }) {
        nodes {
          _id
          fromId
          text
          created
          attachments {
            uploadId
            contentType
            url
            thumbnailUrl
            uploadComplete
            expired
            deleted
          }
        }
      }
    }
  }
`;

export const USER_CHATS = gql`
  query UserChats($userId: String!) {
    userChats(
      userId: $userId
      paging: { type: "page", pageArgs: { page: 1, limit: 200 } }
    ) {
      nodes {
        _id
        updatedDate
        members {
          _id
          username
          profilePhoto {
            url
            thumbnailUrl
          }
          photos {
            url
            thumbnailUrl
          }
        }
        lastMessage {
          _id
          text
          created
          fromId
        }
      }
    }
  }
`;

